var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.701 21.475C54.1465 19.4199 52.546 17.8145 50.4971 17.2583C46.811 16.25 31.9756 16.25 31.9756 16.25C31.9756 16.25 17.1401 16.2806 13.4541 17.2889C11.4051 17.845 9.80461 19.4504 9.25018 21.5056C8.13523 28.075 7.70266 38.0851 9.28064 44.3917C9.83507 46.4469 11.4356 48.0523 13.4845 48.6084C17.1706 49.6167 32.006 49.6167 32.006 49.6167C32.006 49.6167 46.8415 49.6167 50.5275 48.6084C52.5765 48.0523 54.177 46.4469 54.7314 44.3917C55.9073 37.8131 56.2698 27.8092 54.701 21.475Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2538 40.0835L39.5608 32.9335L27.2538 25.7834V40.0835Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 15.5,
    stroke: "#A18BC4",
    strokeOpacity: 0.73
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 33.5,
    fill: "white",
    transform: "translate(8.25 16.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.44c38ec532543ea5a3e156bca97dc443.svg";
export { ForwardRef as ReactComponent };